import styled from 'styled-components';

const s = {
  viralWrapper: styled.div`
    font-family: 'Pluto Sans SemiBold', sans-serif;
    width: 70%;
    height: 100%;
    margin: 0 auto;
    @media (max-width: 767px) {
      width: 100%;
    }
  `,

  viralVideoFrame: styled.div`
    position: relative;
    text-align: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: opacity 0.3s;
    padding: 10px 5px 10px 10px;
  `,

  viralListItemLink: styled.div`
    width: calc(100vw * 0.2);
    height: calc(100vw * 0.12);
    margin-right: 8px;
    display: inline-block;
    white-space: nowrap;
    cursor: pointer;
    position: relative;
    pointer-events: all;
    z-index: 25;
    color: #fff;
    :hover,
    :active {
      background: #1f1f1f;
    }
    @media (max-width: 767px) {
      margin-right: 5px;
      width: calc(100vw * 0.42);
      height: calc(100vw * 0.25);
    }
  `,

  viralClipImage: styled.div`
    background-image: url(${(props) => props.imageURL});
    transition: background 0.1s cubic-bezier(0.4, 0, 1, 1);
    border-radius: 5px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  `,

  viralPlayButton: styled.span`
    position: absolute;
    background-color: #2d1c1c;
    top: 37%;
    left: 42%;
    width: 46px;
    height: 46px;
    border-radius: 31px;
    opacity: 0.8;
    svg:first-child {
      position: absolute;
      left: 6px;
      top: 6px;
      width: 35px;
      height: 35px;
    }
    @media (max-width: 1200px) {
      top: calc(100% * 0.3);
    }
    @media (max-width: 767px) {
      top: 25%;
      left: 36%;
      border-radius: 25px;
      svg {
        width: 30px;
        height: 30px;
      }
    }
  `,

  viralClipNameWrapper: styled.span`
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
    :hover {
      opacity: 1;
    }
  `,

  viralClipName: styled.span`
    position: absolute;
    text-align: left;
    font-size: 17px;
    color: white;
    bottom: 17px;
    left: 17px;
    white-space: break-spaces;
    transition: opacity 0.3s;
    line-height: 15px;
    @media (max-width: 767px) {
      font-size: 14px;
      bottom: 10px;
      left: 10px;
    }
  `,

  viralCountdown: styled.span`
    svg:nth-child(2) {
      position: absolute;
      top: 0;
      left: 0;
      width: 48px;
      height: 48px;
      transform: rotateY(-180deg) rotateZ(-90deg);
    }
    svg:nth-child(2) circle {
      stroke-dasharray: 137px;
      stroke-dashoffset: 0px;
      stroke-linecap: round;
      stroke-width: 2px;
      stroke: white;
      fill: none;
      animation: countdown ${(props) => props.countdownTime/1000}s linear 1 forwards;
    }

    @keyframes countdown {
      from {
        stroke-dashoffset: 0px;
      }
      to {
        stroke-dashoffset: 137px;
      }
    }
  `,
};

export default s;
